import { VehicleTypeSelectOutputWithStatus } from './vehicle-type-select-output-with-status.model';


export class VehicleTypeSelectByIdOutput implements IVehicleTypeSelectByIdOutput {
    status!: number;
    message!: string;
    data!: VehicleTypeSelectOutputWithStatus;

    constructor(data?: IVehicleTypeSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? VehicleTypeSelectOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleTypeSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypeSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IVehicleTypeSelectByIdOutput {
    status: number;
    message: string;
    data: VehicleTypeSelectOutputWithStatus;
}

